// NDH Theme - Base JavaScript
// Import shared global JavaScript
// Shared global JavaScript is loaded via the main js/app.js file

// NDH theme-specific JavaScript functionality
console.log('NDH theme JavaScript loaded');

// Add any NDH theme-specific JavaScript here
// Example: theme-specific UI components, utilities, etc.
